module.exports = __webpack_public_path__ + "img/main_heading_UK.438c88a7.svg";